// Aba ScontiPoste no painel do Manager (adesao ao canal)
const channelSellerDictPT = {
  settingsTabScontiPoste: "ScontiPoste",
  channelSellerTitle: "Venda na ScontiPoste",
  channelSellerIntro: "A ScontiPoste é o programa de cashback da Poste Italiane para quem tem cartão Postepay ou BancoPosta. Ao aderir, seus produtos elegíveis aparecem na vitrine Extraconomy para a ScontiPoste.",
  channelSellerOnlyManagers: "Só Managers podem vender na ScontiPoste.",
  channelSellerEligibleCount: "Produtos elegíveis: {count}",
  channelSellerListedCount: "Produtos na vitrine: {count}",
  channelSellerNoEligible: "Nenhum produto elegível por enquanto. Veja abaixo o que falta em cada produto.",
  channelSellerTerms: "Condições",
  channelSellerTerm1: "Em cada venda na ScontiPoste, {percent}% do valor dos produtos é descontado de você como cashback ScontiPoste. Quem credita ao cliente é a Poste Italiane.",
  channelSellerTerm2: "A taxa da Extraconomy e as comissões da rede continuam as mesmas.",
  channelSellerTerm3: "Você vende só produtos em euro, com frete grátis por sua conta ou retirada na loja.",
  channelSellerTerm4: "Você pode sair quando quiser: os produtos somem da vitrine na hora e os pedidos já recebidos continuam a ser atendidos.",
  channelSellerTermsOutdated: "O cashback ScontiPoste mudou para {percent}%. Seus produtos estão fora da vitrine até você aceitar o novo percentual.",
  channelSellerAcceptNew: "Aceitar {percent}%",
  channelSellerAccept: "Aceito as condições de venda na ScontiPoste",
  channelSellerMode: "O que mostrar na vitrine",
  channelSellerModeAll: "Todos os produtos elegíveis, inclusive os que eu cadastrar depois",
  channelSellerModeSelected: "Só os produtos que eu escolher",
  channelSellerJoin: "Aderir à ScontiPoste",
  channelSellerJoined: "Você está na ScontiPoste desde {date}, com {percent}% de cashback.",
  channelSellerChannelInactive: "A vitrine ScontiPoste ainda não está aberta ao público: seus produtos aparecem quando ela abrir.",
  channelSellerOpenShowcase: "Abrir a vitrine",
  channelSellerProducts: "Seus produtos",
  channelSellerSave: "Salvar produtos",
  channelSellerSaved: "Produtos salvos",
  channelSellerLeave: "Sair da ScontiPoste",
  channelSellerLeaveConfirm: "Seus produtos somem da vitrine ScontiPoste na hora. Os pedidos já recebidos continuam a ser atendidos. Quer sair?",
  channelSellerLeft: "Você saiu da ScontiPoste",
  channelSellerJoinedToast: "Adesão confirmada",
  channelSellerAcceptRequired: "Aceite as condições para aderir.",
  channelReasonSELLER_TYPE: "Só Manager",
  channelReasonNOT_PUBLISHED: "Não publicado",
  channelReasonSHIPPING_OPTION: "Frete pago: use frete grátis ou retirada na loja",
  channelReasonCURRENCY: "Preço fora de euro",
  channelReasonDOWNLOADABLE: "Produto digital",
  channelReasonSERVICE: "Serviço",
  channelReasonDROPSHIPPING: "Produto importado (dropshipping)",
  channelReasonOUT_OF_STOCK: "Esgotado",
  channelError500435: "Só Managers podem vender na ScontiPoste.",
  channelError500436: "Aceite as condições para aderir.",
  channelError500437: "Você ainda não aderiu à ScontiPoste.",
};

export default channelSellerDictPT;
